/**
 * Created by Rodrigo Quesada on 23/03/17.
 */
import {Roles} from './roles';
import {MixinConstructor} from '../../common/mixins/mixins';
import {EmptyClass} from '../../common/mixins/empty-class.class';

export const RolesAware = <T extends MixinConstructor<object>>(Base: T = EmptyClass as T) => {
    return class extends Base {
        Roles = Roles;

        constructor(...args: any[]) { super(...args); }
    };
};



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/domain/authorization/roles-aware.class.ts